export const useClaimLabState = () =>
  useState('claimLab', () => ({
    connectorName: null,
    claim: null,
  }))
